<template>
    <van-popup v-if="selectWorkOrderPopupShow" :value="selectWorkOrderPopupShow" z-index="100" :close-on-click-overlay="false"
               :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">
        <div class="select_order_wrap" v-loading="loading">
            <div class="select_order_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                    <div class="checked_arr">
                        <van-checkbox icon-size="16px"    v-model="allChecked" @click="handleChangeAllCheck()" shape="square"><span>全选</span></van-checkbox>
                    </div>
                </div>
                <div class="search_wrap">
                    <van-search v-model="searchForm.keyword"  placeholder="请输入需要查询的内容"  @clear="handleClickSearch" @search="handleClickSearch">
                        <template #right-icon>
                            <i class="iconfont icon-rili" @click="calendarShow = true"></i>
                        </template>
                    </van-search>
                </div>
            </div>
            <div class="select_order_bottom">
                <van-checkbox-group  v-model="selectionIds">
                    <ul v-infinite-scroll="onLoadList">
                        <li v-for="item in  tableData">
                            <div class="select_order_check">
                                <van-checkbox icon-size="16px" :disabled="disabledData.find(find => find.workorder_id == item.workorder_id) ? true : false" :name="item.workorder_id" @click="handleChangeCheck(item)" shape="square"></van-checkbox>
                                <span class="link-label" v-text="item.workorder_num"></span>
                            </div>
                            <div class="select_order_list">

                                <div class="field_item">
                                    <span class="field_name">发起人</span>
                                    <span class="field_value">
                                         <div class="user_head" @click="handleClickUserDetail(item.user.id)">
                                             <img :src="item.user.avatar ? item.user.avatar : defaultImg" alt="" />
                                             <span v-text="item.user.name"></span>
                                         </div>
                                    </span>
                                </div>
                                <div class="field_item">
                                    <span class="field_name">工单类型</span>
                                    <span class="field_value">
                                         <span class="bold_text" v-if="item.workorder_type_id" v-text="item.workorder_type_id.name"></span>
                                    </span>
                                </div>
                                <div class="field_item">
                                    <span class="field_name">计划时间</span>
                                    <span class="field_value">
                                        <span v-text="item.plan_start_date"></span>
                                        <span v-text="item.plan_start_time == 1 ? '上午': '下午'"></span> -
                                        <span v-text="item.plan_end_date"></span>
                                        <span v-text="item.plan_end_time == 1 ? '上午': '下午'"></span>
                                    </span>
                                </div>
                                <div class="field_item">
                                    <span class="field_name">实施人</span>
                                    <span class="field_value" v-if="item.processing_users">
                                          <span v-text="item.processing_users.map(map => map.processing_user.name).join(',')"></span>
                                    </span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </van-checkbox-group>
            </div>

            <div class="select_order_btn">
                <van-button  @click="handleClickConfirm"  :disabled="BtnDisabled"  type="info" size="small" >确定</van-button>
            </div>

            <van-popup v-model="calendarShow" :close-on-click-overlay="true"  :style="{ height: '70vh',background:'#F7F8FA' }"  position="bottom"  round  @click-overlay="handleClickPopupRangeCalendarClose">
                <van-calendar  :allow-same-day="true" :max-date="dateCalendarMax" :min-date="dateCalendarMin" :default-date="defaultDate"	 :poppable="false"
                               :show-confirm="true" :show-title="false"  color="#1990FF" type="range" @confirm="handleClickRangeCalendarConfirm"></van-calendar>

            </van-popup>

            <userDetailDialog  v-if="userDetailPopupShow" :userDetailPopupShow.sync="userDetailPopupShow"  :userId="userDetailId" />

        </div>
    </van-popup>
</template>

<script>
import {getWorkOrderList} from "@/api/index.js"
import {pagination} from '@/mixins'
import {formatDate} from "@/utils";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
export default {
    name: "select_work_order",
    components: {userDetailDialog},
    props: {
        selectWorkOrderPopupShow: {
            type: Boolean,
            default: false
        },
        pk_sort: {
            type: Object,
            default: ()=>{}
        },
        selectData:{
            type:Array,
            default:()=>[]
        },
        disabledData:{
            type:Array,
            default:()=>[]
        },
    },
    data() {
        return {
            defaultImg: require('@/assets/images/default.jpg'),
            loading:false,
            searchForm:{
                keyword:'',
                created_at:''
            },

            BtnDisabled:false,
            tableData:[],
            selectionIds:[], //选中的id
            multipleSelection:[],//选中的数据
            calendarShow:false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
            defaultDate:[],
            allChecked:false,
            userDetailPopupShow:false,
            userDetailId:0
        };
    },
    mixins: [pagination],
    created() {
        this.multipleSelection = JSON.parse(JSON.stringify(this.selectData))
        this.selectionIds = this.multipleSelection.map(item=>item.workorder_id)
        this.getTableData()
    },
    methods: {
        handleChangeAllCheck(){
            if(this.allChecked){
                this.selectionIds = this.tableData.filter(item => !this.disabledData.some(disabledItem => disabledItem.workorder_id === item.workorder_id)).map(item=>item.workorder_id)
                this.multipleSelection = JSON.parse(JSON.stringify(
                        this.tableData.filter(item => !this.disabledData.some(disabledItem => disabledItem.workorder_id === item.workorder_id))
                ))
            }else{
                this.selectionIds = []
                this.multipleSelection = []
            }
        },
        handleChangeCheck(item){
            if(this.selectionIds.includes(item.workorder_id)){
                this.multipleSelection.push(item)
            }else{
                this.multipleSelection.splice(this.multipleSelection.findIndex(item=>item.workorder_id == item.workorder_id),1)
            }
        },
        handleClickUserDetail(uid){
            this.userDetailId = uid
            this.userDetailPopupShow = true
        },
        handleClickSearch(){
            this.tableData = []
            this.pagination.pageNum = 1
            this.getTableData()
        },
        onLoadList(){
            if(this.pagination.total == this.tableData.length){
                return false
            }
            if(this.loading == false){
                this.getTableData();
            }
        },
        getTableData(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword:this.searchForm.keyword,
                created_at:this.searchForm.created_at,
                pk_sort:this.pk_sort
            }
            getWorkOrderList(postData).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    data.forEach(item=>{
                        this.$set(item,'workorder_id',item.id)
                    })
                    this.pagination.total = total
                    this.tableData =  this.tableData.concat(data)
                    this.pagination.pageNum++;
                }
                this.loading = false
            })
        },
        // 选择日期
        handleClickRangeCalendarConfirm(range){
            const [start, end] = range
            let value = [formatDate(start, 'date'), formatDate(end, 'date')]
            this.searchForm.created_at = value
            this.calendarShow = false
            this.handleClickSearch()
        },
        // 取消选择日期
        handleClickPopupRangeCalendarClose(){

        },

        handleClickConfirm() {
            this.$emit('success',this.multipleSelection)
            this.$emit("update:selectWorkOrderPopupShow", false)
        },
        handleClickClose(){
            this.$emit("update:selectWorkOrderPopupShow", false)
        },

    },
}
</script>

<style  lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
</style>